//
// footer-init.js
// Initialize footer animated background
//

(function () {
  function initFooterNavigation() {
    const groups = document.querySelectorAll('.site-footer__group');
    const mobile = window.matchMedia('(max-width: 767.98px)');
    const syncLayout = () => {
      groups.forEach((group) => {
        group.open = !mobile.matches;
        group.querySelector('summary').tabIndex = mobile.matches ? 0 : -1;
      });
    };

    groups.forEach((group) => {
      group.querySelector('summary').addEventListener('click', (event) => {
        if (!mobile.matches) event.preventDefault();
      });
      group.addEventListener('toggle', () => {
        if (mobile.matches && group.open) {
          groups.forEach((other) => {
            if (other !== group) other.open = false;
          });
        }
      });
    });
    mobile.addEventListener('change', syncLayout);
    syncLayout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterNavigation);
  } else {
    initFooterNavigation();
  }

  function initFooterBackground() {
    if (
      !window.TheyBackgroundGenerator ||
      !window.TheyBackgroundGenerator.createAnimatedBackground
    ) {
      return false;
    }

    const footerBg = document.getElementById('footer-animated-bg');
    if (!footerBg) {
      return false;
    }

    window.TheyBackgroundGenerator.createAnimatedBackground(footerBg, 'footer-2024', {
      blobCountMin: 6,
      blobCountMax: 10,
      animationDuration: 10,
      glowIntensity: 0.5,
    });

    return true;
  }

  // Try multiple times with delays
  let attempts = 0;
  const maxAttempts = 10;

  function tryInit() {
    if (initFooterBackground()) {
      return; // Success!
    }

    attempts++;
    if (attempts < maxAttempts) {
      setTimeout(tryInit, 100); // Try again in 100ms
    } else {
      console.error('Failed to initialize footer background after', maxAttempts, 'attempts');
    }
  }

  // Start trying when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }
})();
